import React, {useState, useRef} from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Container,
  Box,
  Stack
} from '@mui/material';
import AdvancedOptions from '../../Prepostlearning/Assessment/AdvancedOptions';
import PreLearningPublish from '../../Prepostlearning/Assessment/PreLearningPublish';
import QuestionsSetup from '../../Prepostlearning/Assessment/QuestionsSetup';
import AssessmentForm from './AssessmentOnlineTest';
import {useOnlineContext} from './OnlineTestContext';
import {LoadingButton} from '@mui/lab';
import AdvanedOptionsOnlineTest from './AdvanedOptionsOnlineTest';
import QuestionSetupOnlineTest from './QuestionSetupOnlineTest';
import OnlineQuestionPublish from './OnlineQuestionPublish';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {useBoolean} from 'src/hooks/use-boolean';
import {ConfirmLMSDialog} from '@components/custom-dialog';
interface AssessmentStepperProps {
  onClose: () => void;
}

// const steps = [
//   {key: 0, value: 'Assessment Setup'},
//   {key: 1, value: 'Questions'},
//   {key: 2, value: 'Advanced Options'},
//   {key: 3, value: 'Publish'}
// ];
const steps = [
  {key: 0, value: 'Assessment Setup'},
  {key: 1, value: 'Questions'},
  {key: 2, value: 'Publish'}
];

const OnlineSetUp: React.FC<AssessmentStepperProps> = ({onClose}) => {
  const {screenLoader} = useOnlineContext();
  const [activeStep, setActiveStep] = useState(0);
  const {screenSave, setScreenSave} = useOnlineContext();
  const [close, setClose] = useState(false);
  const confirm = useBoolean();
  // Ref to store child save methods
  const childSaveRef = useRef<(() => Promise<boolean>) | null>(null);

  const handleNavigation = async (nextStep: number) => {
    if (childSaveRef.current) {
      const isSaved = await childSaveRef.current();
      if (!isSaved) {
        return;
      }
    }
    setActiveStep(nextStep);
  };
  const handleclose = async (value: boolean) => {
    if (activeStep !== 0) {
      //console.log('activeStep3', activeStep);
      if (value) {
        if (childSaveRef.current) {
          const isSaved = await childSaveRef.current();
          if (!isSaved) {
            return;
          }
        }
      }
    } else if (value) {
      if (childSaveRef.current) {
        const isSaved = await childSaveRef.current();
        if (!isSaved) {
          return;
        }
      }
    }
    onClose();
  };
  const handleNext = () => handleNavigation(activeStep + 1);
  const handleBack = () => handleNavigation(activeStep - 1);
  const handleStepClick = (stepKey: number) => handleNavigation(stepKey);

  const handleSave = () => {
    //console.log('Publishing assessment');
  };

  const getStepContent = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <AssessmentForm setSaveRef={childSaveRef} />;
      case 1:
        return <QuestionSetupOnlineTest setSaveRef={childSaveRef} />;
      case 2:
         return <OnlineQuestionPublish setSaveRef={childSaveRef} />;
        // return <AdvanedOptionsOnlineTest setSaveRef={childSaveRef} />;
      case 3:
        return <OnlineQuestionPublish setSaveRef={childSaveRef} />;
      default:
        return 'Unknown Step';
    }
  };

  if (screenLoader) {
    return (
      <Stack
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh">
        <LoadingScreen />
      </Stack>
    );
  }

  return (
    <Container>
      <Box sx={{py: 3}}>
        <Stepper activeStep={activeStep}>
          {steps.map(step => (
            <Step key={step.key}>
              <StepLabel
                sx={{cursor: 'pointer !important'}}
                onClick={() => handleStepClick(step.key)}>
                {step.value}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box sx={{minHeight: '75vh', py: 2}}>{getStepContent(activeStep)}</Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 2
          }}>
          <Box>
            {activeStep > 0 && (
              <LoadingButton
                loading={screenSave}
                onClick={handleBack}
                variant="outlined"
                sx={{mr: 1}}>
                Back
              </LoadingButton>
            )}
            {activeStep < steps.length - 1 && (
              <LoadingButton
                loading={screenSave}
                onClick={handleNext}
                variant="contained"
                color="primary">
                Next
              </LoadingButton>
            )}
          </Box>
          <Button
            onClick={() => confirm.onTrue()}
            variant="contained"
            color="error">
            close
          </Button>
        </Box>
      </Box>
      <ConfirmLMSDialog
        open={confirm.value}
        onClose={() => {
          confirm.onFalse();
          handleclose(true);
        }}
        onCancel={confirm.onFalse}
        title="Close"
        content="Are you sure want to Close without saving?"
        action={
          <LoadingButton
            variant="contained"
            color="error"
            onClick={() => {
              confirm.onFalse();
              handleclose(false);
            }}>
            Yes
          </LoadingButton>
        }
      />
    </Container>
  );
};

export default OnlineSetUp;
